import React from "react";
import styled from "styled-components";

const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

const StyledSlider = styled.input`
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  background: var(--color-sky-200);
  border-radius: 4px;
  outline: none;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    transition: background-color 0.2s ease;
    background: var(--color-sky-500);
    border-radius: 50%;
    cursor: pointer;

    &:hover {
      background: var(--color-sky-600);
    }
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: var(--color-sky-500);
    transition: background-color 0.2s ease;
    border-radius: 50%;
    cursor: pointer;
    border: none;

    &:hover {
      background: var(--color-sky-600);
    }
  }
`;

function RangeSlider({ title, min, max, value, onChange, formatValue = null }) {
  const formattedValue = formatValue ? formatValue(value) : `${value}`;
  return (
    <SliderContainer>
      <span>{title}</span>
      <StyledSlider
        type="range"
        min={min}
        max={max}
        step={1}
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value, 10))}
      />
      <span>{formattedValue}</span>
    </SliderContainer>
  );
}

export default RangeSlider;
